import {
    FETCH_ORDERS_FAILURE,
    FETCH_ORDERS_REQUEST,
    FETCH_ORDERS_SUCCESS,
    MARK_PRODUCT_WITHDRAWN,
    POST_ORDERS_FAILURE,
    POST_ORDERS_REQUEST,
    POST_ORDERS_SUCCESS,
} from '../../actionTypes';
import { shouldFetch } from '../../fetchStatus';
import { apiClient } from '../../../helpers/apiHelperV2';
import { ordersResponseSelector } from '../../selectors/account/orders';

async function fetchOrders(dispatch) {
    dispatch({
        type: FETCH_ORDERS_REQUEST,
        payload: {},
    });
    try {
        const res = await apiClient.get('/api/v1/account/orders', { authenticated: true });
        dispatch({
            type: FETCH_ORDERS_SUCCESS,
            payload: { orders: res.data ? res.data : undefined },
        });
    } catch (error) {
        dispatch({
            type: FETCH_ORDERS_FAILURE,
            payload: { error },
        });
    }
}

export const fetchOrdersIfNeeded = () => {
    return async function (dispatch, getState) {
        const state = getState();
        const ordersResponse = ordersResponseSelector(state);

        if (shouldFetch(ordersResponse.status)) {
            await fetchOrders(dispatch);
        }
    };
};

export const refetchOrders = () => {
    return async function (dispatch) {
        await fetchOrders(dispatch);
    };
};

export const markProductWithdrawn = ({ orderId, productId }) => ({
    type: MARK_PRODUCT_WITHDRAWN,
    payload: { orderId, productId },
});

export const postOrder = ({ orderId, productId, action }) => {
    return async function (dispatch) {
        dispatch({
            type: POST_ORDERS_REQUEST,
            payload: {},
        });
        try {
            const res = await apiClient.post('/api/v1/account/orders', { orderId, productId, action }, { authenticated: true });
            dispatch({
                type: POST_ORDERS_SUCCESS,
                payload: { orders: res.data ? res.data : undefined },
            });
        } catch (error) {
            dispatch({
                type: POST_ORDERS_FAILURE,
                payload: { error },
            });
        }
    };
};
